
<mat-expansion-panel
  class="add-exp animate__animated animate__fadeIn"
  [disabled]="this.dis"
>
  <mat-expansion-panel-header
    style="
      height: 55px !important;
      min-height: 55px !important;
      max-height: 55px !important;
      position: relative;
    "
  >
    <mat-panel-title>
      <input class="mat-header-input no-input" readonly value="{{ this.banco }}"/>
    </mat-panel-title>
    <mat-panel-description style="justify-content: flex-end; gap: 10px;">

      <div *ngIf="initialTercerosState" class="label-cuenta-terceros" >Cuenta de terceros</div>

      <span *ngIf="sw_edit">
        <i
          matTooltip="Es la dirección principal"
          class="material-icons {{ this.star_class }}"
          (click)="set_principal()">
          {{ this.star }}
        </i>
      </span>

      <!-- <span *ngIf="validated">       
        <i class="material-icons {{this.validated_status}} "
          matTooltip="{{this.validated_tooltip}}">
        {{ this.validated_icon }}
        </i> 
      </span> -->

      <span>
        <i class="material-icons" style="color: #404040;">
        edit
        </i>
      </span>

    </mat-panel-description>

    <span class="span-region">
      {{ this.is_primary_text + " / " + this.proveedor }}
    </span>
  </mat-expansion-panel-header>

  <form [formGroup]="valForm" (submit)="submitForm($event, valForm.value)">
    <mat-form-field appearance="fill">
      <input
        type="text"
        placeholder="Banco"
        required
        formControlName="bank"
        matInput
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="filtrar_banco($event.option)"
      >
        <mat-option
          data-id="{{ option.id }}"
          *ngFor="let option of filteredOptions | async"
          [value]="option.name"
        >
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-hint>Indique el banco</mat-hint>
      <mat-error
        *ngIf="
          valForm.controls['bank'].hasError('required') &&
          (valForm.controls['bank'].dirty || valForm.controls['bank'].touched)
        "
      >
        El banco es <strong>requerido</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-select
        placeholder="Tipos de Cuenta"
        formControlName="type"
        [(ngModel)]="this.account_selected"
        required
      >
        <mat-option *ngFor="let cuenta of cuentas" [value]="cuenta.id">
          {{ cuenta.name }}
        </mat-option>
      </mat-select>
      <mat-hint>Indique el tipo de cuenta</mat-hint>
      <mat-error
        *ngIf="
          valForm.controls['type'].hasError('required') &&
          (valForm.controls['type'].dirty || valForm.controls['type'].touched)
        "
      >
        El tipo de cuenta es <strong>requerido</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <input
        matInput
        placeholder="Nombre y Apellido"
        formControlName="name"
        required
        (input)="formatAccountName($event)"
      />
      <mat-hint>Indique el nombre de la cuenta</mat-hint>
      <mat-error
        *ngIf="
          valForm.controls['name'].hasError('required') &&
          (valForm.controls['name'].dirty || valForm.controls['name'].touched)
        "
      >
        El nombre es <strong>requerido</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <input
        matInput
        placeholder="Número de cuenta"
        (input)="formatAccountNumber($event)"
        formControlName="number"
        type="text"
        required
      />
      <mat-hint>Indique el número de cuenta</mat-hint>
      <mat-error
        *ngIf="
          valForm.controls['number'].hasError('required') &&
          (valForm.controls['number'].dirty ||
            valForm.controls['number'].touched)
        "
      >
        El número de cuenta es <strong>requerido</strong>
      </mat-error>
      <mat-error
        *ngIf="
          valForm.get('number')?.hasError('pattern') &&
          (valForm.get('number')?.dirty || valForm.get('number')?.touched)">
        El número de cuenta debe ser numérico y contener de 6 a 12 digitos
      </mat-error>
    </mat-form-field>

    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top">
        <mat-slide-toggle
          color="primary"
          formControlName="tercero"
          [(ngModel)]="is_tercero"
          style="
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 12px;
            font-size: DM Sans;
            color: gray;"
          [disabled]="true">
          Cuenta de terceros</mat-slide-toggle
        >
      </div>

      <div
        class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top"
        style="text-align: left"
      >
        <button
          type="button"
          *ngIf="initialTercerosState"
          (click)="archivo_terceros(id)"
          style="margin-top: 10px"
          mat-mini-fab
          color="primary"
          aria-label="Agregar archivos de tercero"
          [disabled]="checkingDocuments">
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>
    </div>

    <mat-form-field appearance="fill">
      <input
        matInput
        placeholder="RUT"
        formControlName="rut"
        [(ngModel)]="run"
        (input)="change_run($event)"
        maxlength="10"
        required
      />
      <mat-hint>Indique el RUT del número de cuenta</mat-hint>
      <mat-error
        *ngIf="
          valForm.get('rut')?.hasError('required') &&
          (valForm.get('rut')?.dirty || valForm.get('rut')?.touched)">
        El RUN es <strong>requerido</strong>
      </mat-error>
      <mat-error
        *ngIf="
          valForm.get('rut')?.hasError('pattern') &&
          (valForm.get('rut')?.dirty || valForm.get('rut')?.touched)">
        El RUN debe ser en formato 12345678-9
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="fill">
      <input matInput placeholder="Email" formControlName="email" />
      <mat-hint>Indique el correo electrónico de la cuenta</mat-hint>
      <mat-error
        *ngIf="
          valForm.get('email')?.hasError('pattern')">
        El email debe tener un formato válido
      </mat-error>
    </mat-form-field>
    
    <!-- Input de archivo para cuentas de terceros -->
    <div *ngIf="showFileInput && !initialTercerosState">
      <mat-form-field appearance="fill">
        <input 
          class="no-input" 
          readonly 
          (click)="fileInput.click()" 
          matInput 
          formControlName="file" 
          placeholder="Carga el archivo de terceros" 
          [(ngModel)]="placeholder"
        >
        <mat-error 
          *ngIf="valForm.get('file')?.hasError('required') && valForm.get('file')?.touched"
        >
          El archivo de terceros es requerido
        </mat-error>
        <mat-icon 
          matSuffix 
          (click)="fileInput.click()" 
          style="cursor: pointer;"
        >
          attach_file
        </mat-icon>
      </mat-form-field>
      
      <input 
        #fileInput 
        type="file" 
        style="display: none;" 
        (change)="onFileSelected($event)"
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
      >
    </div>


    <div style="margin-top: 30px; display: flex; flex-wrap: wrap">

      <button
        *ngIf="sw_edit"
        type="button"
        (click)="delete_add()"
        [disabled]="disabled_delete"
        mat-stroked-button
        color="primary"
        class="secondary-button">
        Eliminar
      </button>

      <button
        *ngIf="sw_edit"
        type="submit"
        mat-stroked-button
        color="primary"
        class="primary-button">
        <span *ngIf="!showSpinner">Actualizar cuenta</span>
        <span *ngIf="showSpinner">
          <i class="fa-solid fa-circle-notch fa-spin-pulse"></i>
        </span>
      </button>

      <button
        *ngIf="sw_edit"
        type="button"
        (click)="validate_account()"
        [disabled]="disabled_validator"
        mat-stroked-button
        color="primary"
        class="primary-button"
      >
        Validar cuenta
      </button>
    </div>
  </form>
</mat-expansion-panel>
